import { Selector, SizeVariant } from '@outdoorsyco/bonfire';
import { useIntl } from 'react-intl';

import { localeOptions, useSessionLocale } from '@/hooks/useSessionLocale';

type TLanguageSelectorProps = {
  onSelect?: () => void;
};

export const LanguageSelector = ({ onSelect }: TLanguageSelectorProps) => {
  const intl = useIntl();

  const [selectedLocale, updateLocale] = useSessionLocale();

  // We intentionally use standalone Selector instead of SelectorGroup + RadioSelector.
  // SelectorGroup uses a radio group pattern where arrow key navigation immediately triggers
  // onChange, which would close this modal on every keystroke. Selector (checkbox-based)
  // only commits on Space/click, so keyboard users can Tab through options freely.
  return (
    <div
      role="group"
      aria-label={intl.formatMessage({
        id: 'QSb3/C',
        defaultMessage: 'Select language',
        description: 'GlobalHeader > LanguageSelector > aria-label',
      })}
      className="grid grid-cols-1 gap-2 md:grid-cols-2">
      {[...localeOptions]
        .sort(a => (a.value === selectedLocale ? -1 : 0))
        .map(option => (
          <Selector
            key={option.value}
            name="language"
            value={option.value}
            ariaLabel={option.label}
            label={option.data.language}
            description={option.data.name}
            descriptionClassName="text-secondary-base"
            size={SizeVariant.Medium}
            isSelected={option.value === selectedLocale}
            onChange={isSelected => {
              // Selector is a toggle (checkbox) under the hood — guard against the
              // deselect case that fires when clicking the already-selected option.
              if (!isSelected) return;
              updateLocale(option.value);
              onSelect?.();
            }}
          />
        ))}
    </div>
  );
};
